import { useState } from 'react'

import { Link } from 'react-router-dom'
import { auth } from '../../firebaseConnection'
import { createUserWithEmailAndPassword } from 'firebase/auth'
import { useNavigate } from 'react-router-dom'

import { ToastContainer, toast } from 'react-toastify'


export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassord] = useState('')
  const [error, setError] = useState('');
  const navigate = useNavigate();

  async function handleRegister(e) {
    e.preventDefault();

    if (email !== '' && password !== '') {
      await createUserWithEmailAndPassword(auth, email, password)
        .then(() => {
          navigate('/admin', { replace: true })
        })
        .catch(() => {
          console.log("Erro ao fazer o cadastro")
        })

    } else {

      toast.error("Preencha todos os campos!");
      //alert("Preencha todos os campos!")
    }
  }


  return (
    <div className='home-container'>
      <ToastContainer />
      <h1>Cadastre-se</h1>
      <span>Vamos criar sua conta.</span>

      <form className='form' onSubmit={handleRegister}>
        <input
          type='email'
          placeholder='Digite seu email'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          type='password'
          placeholder='Digite sua senha'
          value={password}
          onChange={(e) => setPassord(e.target.value)}
          required
        />

        <button type='submit'>Cadastrar</button>
        {error && <p className="error-message">{error}</p>}
      </form>

      <Link className='button-link' to="/">
        Já possui uma conta? Faça o login
      </Link>

    </div>
  )
}